import { Injectable } from "@angular/core";
import { ApicallOption, ApicallService } from "./apicall.service";
import { Helper, parseList } from "@helpers/functions";
import { Account, PayoutAccount } from "@models";
import { Announcement } from "@models/announcement";
import { AnnouncementModalComponent } from "../../main/components/announcement-modal/announcement-modal.component";
import { ContactService } from "@main-services/contact.service";
import { PayAccountService } from "@main-services/pay_account.service";
import { TranslationService } from "./translation.service";
import { MasterdataService } from "./masterdata.service";
import { CryptoWalletService } from "@main-services/wallet/crypto_wallet.service";
import { ModalService } from "./modal.service";
import { InitService } from "./init.service";
import { ServiceNames } from "@models/service_enums";
import { combineLatest, zip } from "rxjs";
import { BEST_TWO_TERMS_ON_HOLD, TOKEN_BEST_ID } from "@helpers/constants";
import { take, skipWhile } from "rxjs/operators";
import { AccountService } from "../../account/services/account.service";
import { Best2ModalComponent } from "../../main/components/best2-modal/best2-modal.component";
import { WalletsBalancesFacadeService } from "@modules/+new/core/wallets-balances/domain/+state/wallets-balances.facade.service";

// TODO: eslint fix
/* eslint-disable @typescript-eslint/no-explicit-any */
@Injectable({
	providedIn: "root"
})
export class MembersDataService {
	public name: string = ServiceNames.MEMBERS_DATA;

	public constructor(
		private apicallService: ApicallService,
		private accountService: AccountService,
		private contactService: ContactService,
		private translationService: TranslationService,
		private masterService: MasterdataService,
		private cryptoWalletService: CryptoWalletService,
		private payAccountService: PayAccountService,
		private modalService: ModalService,
		private initService: InitService,
		private walletBalanceFacade: WalletsBalancesFacadeService
	) {}

	public initMembersData(): void {
		if (!this.initService.didInit([this.name])) {
			const payoutprovidersOption = new ApicallOption();
			payoutprovidersOption.apiVersion = "v3";
			zip(
				this.apicallService.get("payoutproviders", payoutprovidersOption),
				this.apicallService.get("payoutaccounts"),
				this.apicallService.get("paymentoptions")
			)
				.pipe(take(1))
				.subscribe({
					next: ([payoutProviders, payoutAccounts, paymentOptions]: any) => {
						this.masterService.setProviderFromData(payoutProviders, paymentOptions);
						this.payAccountService.list = parseList(payoutAccounts, PayoutAccount);

						this.contactService.contacts = [];
						this.initBestPopUp();
						this.initWalletBalancesFacade();
						this.initService.init(this.name);
					},
					error: (err) => console.error(err)
				});
		}
	}

	private initBestPopUp(): void {
		// Waiting until Account is set and Masterdata is initiated
		combineLatest([
			this.accountService.accountUpdated.pipe(skipWhile((a: Account) => a == null)),
			this.initService
				.getInitiatedServicesAsObservable()
				.pipe(skipWhile((initiated: string[]) => !initiated.includes(ServiceNames.MASTER_DATA)))
		])
			.pipe(take(1))
			.subscribe((_) => {
				// Once cookie is set, don't create modal again
				// Show modal only if: User hasn't pressed "Do Later", User has not opted in and BEST 2 setting is on
				const hasBestCookie: boolean = Helper.getCookie(BEST_TWO_TERMS_ON_HOLD) === "true";
				// CryptowalletService list is set in initLists on line 73 (before this logic here happens)
				const hasBest: boolean = this.cryptoWalletService
					.getNotEmptyCryptoCoins()
					.some((coin) => coin.getId() === TOKEN_BEST_ID);
				if (
					!hasBestCookie &&
					!this.accountService.account.isBest2TermsAccepted() &&
					!this.masterService.isBest2ProductLive() &&
					this.masterService.isBest2Enabled() &&
					hasBest
				) {
					this.modalService.create(Best2ModalComponent).present();
				}
			});
	}

	public lookUpAnnouncements(data: any): void {
		let list = [];
		if (data["announcement"]) {
			list = parseList(data["announcement"], Announcement);
		}

		if (list.length > 0 && !list[0].isNew()) {
			this.modalService
				.create(AnnouncementModalComponent, { data: list[0] }, { backButtonRoleDismiss: true })
				.present();
		}
	}

	private initWalletBalancesFacade(): void {
		this.walletBalanceFacade.refreshBalances$().toPromise();
	}
}
